if(!customElements.get("hot-spot")){
class hotSpot extends HTMLElement{
    constructor(){
        super()
    }
    connectedCallback(){
        this.mobile_popup = document.querySelector(`#${this.dataset.spotId}`)
        this.init()
        setTimeout(() => this.initMaxWidth());
        // Initialisiere den Intersection Observer nur, wenn das Element die Klasse 'active--onscroll' hat
        if(this.classList.contains("active--onscroll")) this.initScrollActivation();
    }
    init(){
        this.addEventListener("mouseover", this.onMouseOver.bind(this))
        this.addEventListener("mouseleave", this.onMouseLeave.bind(this))
        this.addEventListener("click", this.onClick.bind(this))
        window.addEventListener("resize",this.initMaxWidth.bind(this))
    }
    setActive(){
        // Remove Active Hotspot
        if(document.querySelector(".hotspot.active")){
            document.querySelector(".hotspot.active").classList.remove("active")
        }
        if(window.innerWidth <= 990 ){
            if(!this.mobile_popup){
                this.mobile_popup = document.querySelector(`#${this.dataset.spotId}`)
            }
            // hide active Mobile Popup (Not in Mouseleave to have always 1 popup active)
            if(document.querySelector(".hotspot-popup--mobile.active")){
                document.querySelector(".hotspot-popup--mobile.active").classList.remove("active")
            }
            this.mobile_popup.classList.add("active")
        }
        this.classList.add("active")
    }
    removeActive(){
        this.classList.remove("active")
    }
    onMouseOver(){
        if(window.innerWidth > 990 && !this.classList.contains("active")){
            this.setActive()
        }
    }
    onMouseLeave(){
        if(window.innerWidth > 990 ){
            this.removeActive()
        }
    }
    onClick(){
        if(window.innerWidth <= 990){
            this.setActive()
        }
    }
    initMaxWidth(){
        this.popup = this.querySelector(".hotspot-popup");
        const hotspotRect = this.getBoundingClientRect();
        const windowWidth = window.innerWidth
        if(this.popup.classList.contains("hotspot-popup--left") && hotspotRect.left < 380){
            // Setze die Maximalweite von this.popup auf die Weite zwischen der rechten Kante von this.popup und der linken Bildschirmkante.
            const maxWidth = hotspotRect.left - 20;
            this.popup.style.maxWidth = `${maxWidth}px`;
        }
        else if(this.popup.classList.contains("hotspot-popup--right") && ( windowWidth - hotspotRect.right ) < 380){
            // Setze die Maximalweite von this.popup auf die Weite zwischen der linken Kante von this.popup und der rechten Bildschirmkante.
            const maxWidth = ( windowWidth - hotspotRect.right ) - 20;
            this.popup.style.maxWidth = `${maxWidth}px`;
        }
        else{
            this.popup.style.maxWidth = null
        }
    }
    initScrollActivation() {
            this.section = this.closest('.hotspot-wrapper');
            if (this.section) {
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.section.closest(".hotspot-section-wrapper").querySelector("mobile-hotspot-wrapper").initHeight()
                            if(window.innerWidth > 990){
                               this.onMouseOver()
                               this.observer.unobserve(this.section)
                                // 500 Millisekunden = 0.5 Sekunden 
                            }
                            else{
                                this.onClick()
                            }
                            
                        }
                    });
                }, {
                    threshold: 1.0 // Callback wird aufgerufen, wenn 100% des Elements sichtbar sind
                });
                this.observer.observe(this.section);
            }
    }
}
    customElements.define("hot-spot", hotSpot)

  
class mobileHotspotWrapper extends HTMLElement{
    constructor(){
        super()
    }
    connectedCallback(){
        window.addEventListener("DOMContentLoaded", this.initHeight.bind(this))
        window.addEventListener("resize", this.initHeight.bind(this))
    }
    initHeight(){
        if(!this.popups){
            this.popups = this.querySelectorAll(".hotspot-popup")
        }
        
        this.maxHeight = 0

        this.popups.forEach(popup => {
            if(popup.clientHeight > this.maxHeight){
                this.maxHeight = popup.clientHeight
            }
        })

        this.style.height = this.maxHeight + "px"
    }
}

    customElements.define("mobile-hotspot-wrapper", mobileHotspotWrapper)
}
